import { useState } from "react";
import TopNav from "./components/TopNav";
import BannerCarousel from "./components/BannerCarousel";
import InfluencerSection from "./components/InfluencerSection";
import CategorySection from "./components/CategorySection";
import HotProducts from "./components/HotProducts";
import CrowChatSection from "./components/CrowChatSection";
import PromoCountdown from "./components/PromoCountdown";
import FactoryMemberSection from "./components/FactoryMemberSection";
import BuyerRfqSection from "./components/BuyerRfqSection";
import FaqSection from "./components/FaqSection";
import Footer from "./components/Footer";
import TrustBadgeSection from "./components/TrustBadgeSection";
import EducationBooksSection from "./components/EducationBooksSection";
import DonationSection from "./components/DonationSection";
import LoginModal from "./components/LoginModal";
import CartDrawer from "./components/CartDrawer";
import SeoHead from "@/components/feature/SeoHead";

const SITE_URL = import.meta.env.VITE_SITE_URL || "https://www.crownhongyunmall.com";

const homeJsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "皇冠鸿运商城 Crown HongYun Mall",
    "url": SITE_URL,
    "description": "正品工厂直营，涵盖手机数码、美妆护肤、教育书籍、感恩教育、爱心村童捐赠，全球达人分销。",
    "potentialAction": {
      "@type": "SearchAction",
      "target": `${SITE_URL}/products?q={search_term_string}`,
      "query-input": "required name=search_term_string",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "皇冠鸿运商城 Crown HongYun Mall",
    "url": SITE_URL,
    "logo": {
      "@type": "ImageObject",
      "url": "https://public.readdy.ai/ai/img_res/f704ac6a-a45e-41ab-b34d-a4b4313691a9.png",
    },
    "sameAs": [],
    "description": "皇冠鸿运商城是一家集工厂直营、达人分销、教育书籍、爱心捐赠于一体的综合电商平台。",
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "customer service",
      "availableLanguage": ["Chinese", "English"],
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "工厂入驻需要提交哪些资质证明？",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "工厂入驻需提交以下材料，缺一不可：① 营业执照彩色扫描件；② 生产许可证或行业资质证书；③ 第三方机构出具的产品质量检测报告；④ 法人身份证正反面；⑤ 统一社会信用代码。所有材料均由平台人工核验，确保工厂真实合法经营。",
        },
      },
      {
        "@type": "Question",
        "name": "工厂会员前3个月免费，之后费用是多少？",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "工厂入驻后前3个月完全免费，无需支付任何费用，也无需绑定银行卡。3个月免费期结束后，仅需每月 ¥5 的会员费即可继续享受所有工厂会员权益。可随时取消，不会自动扣费。",
        },
      },
      {
        "@type": "Question",
        "name": "货款托管机制是如何运作的？",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "货款托管流程：① 买家下单付款，资金进入平台托管账户，工厂无法直接提取；② 工厂按时发货，提供高品质商品；③ 买家收货后验收商品质量；④ 买家确认收货且质量合格后，平台自动将货款释放给工厂。如买家对质量有异议，可在收货后7天内发起纠纷，平台介入调查后决定货款归属。",
        },
      },
      {
        "@type": "Question",
        "name": "分销商会员费用是多少？如何加入？",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "分销商会员完全免费，永久免费，无任何隐藏费用。加入步骤：① 注册皇冠鸿运商城账号；② 申请加入分销商计划（24小时内审核）；③ 获得专属推荐链接和推荐码；④ 分享给好友，好友购买即可获得佣金（白银10%、黄金12%、钻石15%）。",
        },
      },
      {
        "@type": "Question",
        "name": "Crowntalk 是什么？国内手机能用吗？",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Crowntalk 是皇冠鸿运商城官方全球社交通讯应用，支持与全球任何人进行文字、语音、高清视频通话，还可分享商城商品礼物。iOS 用户可在 App Store 搜索「Crowntalk」下载；国内华为、小米、OPPO、vivo 等安卓手机可直接下载 APK 安装包，无需 Google 服务，安装简单。",
        },
      },
      {
        "@type": "Question",
        "name": "如果买家收到的商品质量不合格怎么办？",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "买家收货后7天内可发起质量纠纷申请。平台将介入调查，要求工厂提供质检报告和发货凭证，必要时委托第三方机构对商品进行检测。如确认商品质量不合格，平台将：① 退还买家全部货款；② 扣除工厂保证金；③ 视情节轻重暂停或永久取消工厂资格。",
        },
      },
    ],
  },
];

export default function Home() {
  const [cartCount, setCartCount] = useState(0);
  const [loginOpen, setLoginOpen] = useState(false);
  const [cartOpen, setCartOpen] = useState(false);

  const handleAddToCart = () => setCartCount((prev) => prev + 1);

  return (
    <div className="min-h-screen bg-white">
      <SeoHead
        title="皇冠鸿运商城 Crown HongYun Mall | 正品工厂直营 · 全球购物 · 教育书籍 · 爱心捐赠"
        description="皇冠鸿运商城 — 正品工厂直营，手机数码、美妆护肤、教育书籍（高考·研究生·会计·英语·感恩教育），爱心村童捐赠，全球达人分销，Crowntalk 社交购物一体化。"
        keywords="皇冠鸿运商城,工厂直营,教育书籍,高考备考,感恩教育,爱心捐赠,达人分销,正品保障"
        canonical="/"
        jsonLd={homeJsonLd}
      />
      <PromoCountdown />
      <TopNav
        cartCount={cartCount}
        onCartClick={() => setCartOpen(true)}
        onLoginClick={() => setLoginOpen(true)}
      />
      <main>
        <BannerCarousel />
        <CategorySection />
        <InfluencerSection />
        <HotProducts onAddToCart={handleAddToCart} />
        <EducationBooksSection />
        <DonationSection />
        <CrowChatSection />
        <FactoryMemberSection />
        <BuyerRfqSection />
        <FaqSection />
        <TrustBadgeSection />
      </main>
      <Footer />
      <LoginModal isOpen={loginOpen} onClose={() => setLoginOpen(false)} />
      <CartDrawer isOpen={cartOpen} onClose={() => setCartOpen(false)} count={cartCount} />
    </div>
  );
}
